import { Handle, NodeProps, Position } from 'reactflow';
import { GitBranch, Eye } from 'lucide-react';
import { PipelineNodeData } from '../../types/pipeline';

export default function JoinNode({ data, selected }: NodeProps<PipelineNodeData>) {
  return (
    <div
      className={`rounded-lg border bg-white px-3 py-2 shadow-sm ${
        selected ? 'border-cyan-500 ring-2 ring-cyan-200' : 'border-cyan-200'
      }`}
      title="Click to preview joined data"
    >
      <Handle type="target" position={Position.Left} id="left" className="!bg-cyan-500 !-top-1" />
      <Handle type="target" position={Position.Left} id="right" className="!bg-cyan-500 !-bottom-1" />
      <Handle type="source" position={Position.Right} className="!bg-cyan-500" />

      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 text-sm font-semibold text-cyan-700">
          <GitBranch className="h-4 w-4" />
          <span>{data.label}</span>
        </div>

        {/* Preview indicator - shows when selected */}
        {selected && (
          <Eye className="h-3.5 w-3.5 text-cyan-500 opacity-70" />
        )}
      </div>

      {data.description && (
        <p className="mt-1 text-xs text-slate-500">{data.description}</p>
      )}

      {/* Preview hint when selected */}
      {selected && (
        <p className="mt-1 text-xs text-cyan-600 font-medium">
          Preview active
        </p>
      )}
    </div>
  );
}
